module.exports = __webpack_public_path__ + "static/img/Data-Science-is-Different-From-Data-Analytics.83c2fbb7.jpg";